<div class="beta-message">
  <div><span class="fa fa-bullhorn"></span></div>
  <div>
    <div>{{ 'beta.feature_in_dvelopment'| translate }}</div>
    <div class="extra" *ngIf="extra && extra.length > 0">{{ extra }}</div>
  </div>      
</div>